import React  from 'react';
import NavBar from './Components/navbar';
import Carrossel from './Components/Carrossel/Carrossel';
import './App.css';
import MyForm from './Components/formulario';
import foto from './Foto Portfolio.jpg';
import { ReactComponent as FirstSVG } from "./svg's/firstIcons.svg";
import { ReactComponent as SecondSVG } from "./svg's/secondIcons.svg";
import { ReactComponent as ThirdIcon } from "./svg's/thirdIcon.svg";


function App() {

  const data = new Date();
  let experiencie = data.getFullYear() - 2021 



  return(
    <>
      <NavBar/>
      <section  id='home'>
        <h1>Bem-vindo ao meu portfólio!</h1>
        <div>
          <p>
            Bem-vindo ao meu portfólio! Sou um programador com mais de {experiencie} anos de experiência e habilidades em tecnologias como HTML, CSS, JavaScript, ReactJS, SCSS e Bootstrap. Além disso, tenho interesse em banco de dados, processamento de dados e automação de processos, o que me permite trazer um conjunto único de habilidades para qualquer projeto em que trabalho.<br/><br/>
            No meu portfólio, você encontrará uma lista de projetos que já trabalhei, incluindo um site de comércio eletrônico que desenvolvi usando banco de dados MySQL e PHP. Sinta-se à vontade para dar uma olhada nos detalhes de cada projeto e ver o meu trabalho em ação.<br/><br/>
            Se você estiver procurando por um programador confiável e apaixonado por tecnologia, eu gostaria de me candidatar para o seu projeto. Por favor, não hesite em entrar em contato comigo pelo meu endereço de e-mail ou pelo meu perfil no LinkedIn para discutir como posso ajudá-lo a alcançar seus objetivos de negócios. Obrigado por visitar meu portfólio e espero poder trabalhar com você em breve!<br/>
          </p>
          <div style={{width:'30%'}}>
            <FirstSVG/>
          </div>
        </div>
      </section>
      <section  id='sobre'>
        <h1>Um pouco sobre mim</h1>
        <div>
          <p>
            Sou um programador apaixonado por tecnologia e resolução de problemas usando algoritmos. Graduando em Ciência da Computação e experiência em linguagens como C, Python e Java, estou focado em desenvolvimento backend.
            <br/><br/>
             Tenho habilidades em análise de dados com Python e familiaridade com JavaScript. Estou pronto para colaborar em projetos desafiadores e oferecer soluções inovadoras. Aguardo seu contato para discutirmos como posso contribuir para o sucesso do seu projeto!
          </p>
          <div>
            <img 
            alt='Minha imagem' 
            width={"120%"}
            src={foto}
            />
          </div>
        </div>
      </section>
      <section style={{'margin': 'auto'}} id='projetos'>
        <h1 style={{'display': 'block'}}>Projetos</h1>
        <p style={{'margin': 'auto'}}>
          Veja alguns dos meus projetos mais recentes e descubra como eu posso ajudá-lo em seus projetos. Clique nos cards abaixo para explorar mais a fundo o meu trabalho e entrar em contato comigo para discutir como eu posso ajudá-lo a alcançar seus objetivos.
        </p>
        <br/>
        <Carrossel />
      </section>
      <section  id='skills'>
        <h1>Habilidades</h1>
        <div style={{display:"flex"}}>
          <p>
          Sou um programador front-end com mais de {experiencie} anos de experiência em desenvolvimento web. Tenho conhecimentos em diversas tecnologias e linguagens, como JavaScript, ReactJS, Node.js, PHP, MySQL, Python e Django. Além disso, a domino as técnicas de programação orientada a objetos (POO) e operações CRUD em banco de dados. Utilizo o Linux Mint como sistema principal há mais de {experiencie} anos e tenho experiência com o Git para gerenciar o código de meus projetos.
          <br/>
          <br/>
          Atualmente, estou explorando o campo de machine learning e buscando aprimorar meus conhecimentos nessa área. No entanto, meu foco principal continua sendo o desenvolvimento web e a criação de soluções inovadoras e de qualidade.
          <br/>
          <br/>
          Todos os meus projetos estão disponíveis no meu perfil no GitHub. Sinta-se à vontade para dar uma olhada e entrar em contato comigo para mais informações.
          </p>
          <div style={{width:'30%'}}>
            <SecondSVG/>
          </div>
        </div>
      </section>
      <section 
      style={{'display':'flex',
      'justify-content': 'space-between'}} id='contato'>
        <div style={{'display':"flex","flex-direction": "column","width":'70%','justify-content': 'space-between'}}>
          <h1>Entre em contato</h1>
          <p>
            Estou sempre aberto a novos projetos e oportunidades de colaboração. Sinta-se à vontade para entrar em contato comigo pelo formulário ao lado ou pelas minhas mídias sociais.
          </p>
          <div style={{'width':'12em'}}>
            <ThirdIcon/>
          </div>
        </div>
        <MyForm />
      </section>
    </>
  )
}
export default App;